import React, { useState } from "react";
import { ReactComponent as Pattern } from "../../../assets/images/Pattern.svg";
import { ReactComponent as Connection } from "../../../assets/images/connection.svg";
import Styles from "./NoDataPage.module.css";
import { Add } from "@mui/icons-material";
import BankingListingModal from "../../Modals/BankingListingModal/BankingListingModal";

const NoDataPage = ({ isInSelfListing, isInActive, isInConnection }) => {
  const [addListing, setAddListing] = useState(false);
  const handleOpen = () => {
    setAddListing(true);
  };

  const handleClose = () => {
    setAddListing(false);
  };
  return (
    <>
      {addListing && (
        <BankingListingModal
          open={addListing}
          handleClose={handleClose}
          mode="create"
          heading="Add Banking Listing"
        />
      )}

      {isInConnection ? (
        <>
          <div className={`display_flex_row_center ${Styles.noConnectionCont}`}>
            <span className={Styles.connectionImage}>
              <Connection style={{ width: "80%", paddingLeft: "10%" }} />
            </span>
            <div className={`display_flex_row_center ${Styles.activeContent}`}>
              <span>No Counterparty</span>
              <span>Connections</span>
            </div>
            <div
              className={`display_flex_row_center ${Styles.paraActiveContent}`}
            >
              <span> You haven’t sent or received any connection</span>{" "}
              <span>requests. We’ll notify you as soon as one</span>
              <span>becomes available.</span>
            </div>
          </div>
        </>
      ) : isInActive ? (
        <>
          <div className={`display_flex_row_center ${Styles.noConnectionCont}`}>
            <span className={Styles.connectionImage}>
              <Connection style={{ width: "80%", paddingLeft: "10%" }} />
            </span>
            <div className={`display_flex_row_center ${Styles.activeContent}`}>
              <span>No Active Connections</span>
            </div>
            <div
              className={`display_flex_row_center ${Styles.paraActiveContent}`}
            >
              <span> You haven’t accepted any requests yet.</span>{" "}
              <span>Once you do, they’ll appear here so you can</span>
              <span> proceed with Finalizing terms and</span>
              <span>conditions.</span>
            </div>
          </div>
        </>
      ) : (
        <div className={Styles.noDataContainer}>
          {isInSelfListing ? (
            <span>
              <Pattern style={{ width: "80%", paddingLeft: "10%" }} />
            </span>
          ) : (
            <span>
              <Pattern />
            </span>
          )}
          <div className="display_flex_column">
            <div className={Styles.matchingContent}>
              {isInSelfListing ? (
                <>
                  <span>No self-listings </span>
                  <span>available</span>
                </>
              ) : (
                <>
                  <span>No Matching</span>
                  <span>counterparties available </span>
                </>
              )}
            </div>
            <div className={Styles.informContent}>
              {isInSelfListing ? (
                <>
                  <span>No data is available for the</span>
                  <span>selected filter criteria.</span>
                  <div
                    className={`display_flex_row_center ${Styles.addListingButton}`}
                    onClick={handleOpen}
                  >
                    <Add style={{ fontSize: "16px" }} />
                    <span>Add Listing</span>
                  </div>
                </>
              ) : (
                <>
                  <span>There are no counterparties that match</span>
                  <span>your requirements. We’ll inform you as</span>
                  <span> soon as a match is found</span>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoDataPage;
